export default function CreateGroupScreen() {
  return null;
}